<template>
  <div class="card-slider">
    <!--    {{ swiper }}-->
    <DefSliderWrapper>
      <!--        :pagination="{ clickable: true }" navigation-->
      <Swiper
        :modules="modules"
        :slides-per-view="1"
        effect="fade"
        :simulate-touch="false"
        @init="swiper = $event"
      >
        <SwiperSlide v-for="(item, i) in result" :key="i">
          <DefImg :result="item" />
          <GiaPhoto v-if="isGia" />
        </SwiperSlide>
      </Swiper>
    </DefSliderWrapper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { EffectFade } from 'swiper/modules';
import DefSliderWrapper from '@components/sliders/DefSliderWrapper.vue';
import DefImg from '@components/Def/DefImg/DefImg.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';

export default {
  name: 'CardSlider',
  components: {
    GiaPhoto,
    DefImg,
    DefSliderWrapper,
    Swiper,
    SwiperSlide,
  },
  props: {
    result: {
      type: Array,
    },
    isGia: {
      type: Boolean,
      default: () => false,
    },
    isMouseOver: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modules: [EffectFade],
      swiper: null,
    };
  },
  watch: {
    isMouseOver(newValue) {
      if (!this.result?.[1]?.isPicturePlug) {
        if (newValue) {
          this.swiper.slideTo(1);
        } else {
          this.swiper.slideTo(0);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-slider {
  position: relative;
  img {
    display: block;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
  :deep(.swiper-pagination-bullet) {
    width: 6px;
    height: 6px;
    &:not(:last-child) {
      margin-right: 6px;
    }
  }
  :deep(.def-slider-wrapper) {
    margin-bottom: 8px;
  }
  :deep(.gia-photo) {
    max-width: 42px;
    position: relative;
    right: 12px;
    margin-right: 0;
  }
}
</style>
